import React from 'react';
import { EquipmentModel } from '../../../model/equipment-model';
import { entityManagerProvider } from '../../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { Brand } from '../../../model/brand';
interface EquipmentModelList {
  equipmentModel: EquipmentModel[];
  brands: Brand[];
  selected: EquipmentModel;
  ids: number;
  loading: boolean;
  allowAdd: boolean;
}

class EquipmentModels extends React.Component<any, EquipmentModelList> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      equipmentModel: [] as EquipmentModel[],
      brands: [] as Brand[],
      selected: null as EquipmentModel,
      ids: 0 as number,
      loading: true,
      allowAdd: true,
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addEquipmentModel = this.addEquipmentModel.bind(this);
    this.remove = this.remove.bind(this);
    this.setTypeState = this.setTypeState.bind(this);
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('EquipmentModels').expand('brand');
    const queryBrand = new EntityQuery('Brands');
    this.manager.executeQuery(queryBrand).then((qr) => {
      this.setState({
        brands: qr.results,
      });
    });
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        equipmentModel: qr.results,
        loading: false,
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  addEquipmentModel() {
    this.setState({
      ids: this.state.ids - 1,
      allowAdd: false,
    });
    let equipmentModel = this.manager.createEntity(
      EquipmentModel.prototype.entityType,
      {
        equipmentModelId: this.state.ids,
      }
    ) as EquipmentModel;
    // select the new customer, and add it to the list of customers
    this.setState({
      selected: equipmentModel,
      equipmentModel: this.state.equipmentModel.concat([equipmentModel]),
    });
  }

  remove(ent: EquipmentModel) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then(() => {
        // refresh customer list to remove deleted customers
        this.setState({
          selected: null,
          equipmentModel: this.manager.getEntities(
            'EquipmentModel'
          ) as EquipmentModel[],
        });
      })
      .catch((error) => {
        this.setState({
          selected: null,
          equipmentModel: this.manager.getEntities(
            'EquipmentModel'
          ) as EquipmentModel[],
        });
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        this.setState({
          loading: false,
          selected: null,
          allowAdd: true,
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    this.setState({
      selected: null,

      equipmentModel: this.manager.getEntities(
        'EquipmentModel'
      ) as EquipmentModel[],
      allowAdd: true,
    });
  }

  renderPaymentEdit() {
    let equipmentModel = this.state.selected;
    function handleCatChange(event) {
      equipmentModel.brandId = event.target.value;
    }

    if (equipmentModel) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, equipmentModel)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <form>
                <div className="form-group row">
                  <div className="col-lg-12">
                    <label>Brand Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="modelName"
                      value={equipmentModel.modelName || ''}
                      onChange={equipmentModel.handleChange}
                    />
                  </div>
                  <div className="col-lg-12">
                    <label>Category</label>
                    <select
                      className="form-control"
                      name="brandId"
                      onChange={handleCatChange}
                      value={equipmentModel.brandId || 1}
                    >
                      <option key={0}>Select Brand</option>
                      {this.state.brands?.map((cat) => {
                        return (
                          <option key={cat.brandId} value={cat.brandId}>
                            {cat.brandName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  setTypeState(type: EquipmentModel) {
    this.rejectChanges();
    this.setState({ selected: type });
  }
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              Equipment Model
            </h3>
            <span className="text-muted font-weight-bold font-size-sm mt-1">
              e.g. Excavators, Loader, Generator ...
            </span>
          </div>
          <div className="card-toolbar">
            <button
              type="submit"
              className="btn btn-success mr-2"
              onClick={this.addEquipmentModel}
              disabled={!this.state.allowAdd}
            >
              Add EquipmentModel
            </button>
            <button
              type="submit"
              className="btn btn-warning mr-2"
              onClick={() => {
                this.setState({ selected: null, allowAdd: true });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="card-body">
          {this.state.loading ? (
            <div className="row" style={{ minHeight: '200px' }}>
              <Loader
                size="large"
                style={{ position: 'relative', margin: '60px auto' }}
                type="converging-spinner"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-6">
                <div style={{ overflow: 'scroll', height: '300px' }}>
                  <Table className="table" bordered>
                    <thead>
                      <tr>
                        <th>Brand</th>
                        <th>Model</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.equipmentModel?.map((type, idx) => {
                        return (
                          <tr
                            key={type.equipmentModelId}
                            style={{
                              backgroundColor:
                                type === this.state.selected
                                  ? 'lightgray'
                                  : 'white',
                            }}
                            onClick={() => this.setTypeState(type)}
                          >
                            <td>{type.brand?.brandName}</td>
                            <td>{type.modelName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="col-xl-6">{this.renderPaymentEdit()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EquipmentModels;
